/**
 * Normalize legacy descriptors into the complete action graph consumed by
 * generic API/web runtimes. Explicit descriptor values always win; this keeps
 * the migration additive while making omissions fail-closed at dispatch.
 */
export function normalizeActionDescriptor(action) {
    if (action.kind !== 'command' && action.kind !== 'workflowTransition')
        return action;
    const confirmationFields = action.confirmation?.fields?.map(field => field.name) ?? [];
    return {
        ...action,
        method: action.method ?? 'POST',
        payloadSchemaRef: action.payloadSchemaRef ?? (confirmationFields.length ? 'confirmation-fields' : 'no-payload'),
        payloadFields: action.payloadFields ?? confirmationFields,
        invalidationTargets: action.invalidationTargets ?? [String(action.feature)],
    };
}
